export default __webpack_public_path__ + "static/media/521.d930428b.png";